import React from 'react';

const CardGeneric = (props) => {
    let cssClasses = ['card','card--generic'];
    let additionalClasses = (props.additionalClasses) ? props.additionalClasses : [];

    return (
        <div className={cssClasses.join(' ') + ' ' + additionalClasses.join(' ')}>
			{ (props.customTitle) && (
				<div className="card__header">
					{ props.customTitle }
				</div>
			) }
            <div className="card__inner">
                {(props.title) && <h3 className="card__title">{props.title}</h3>}
                <div className="card__content">
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default CardGeneric;
